import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const fetchCatalogItemsQuery = gql`
  query SearchCatalogItems
  (
    $catalog: uuid!,
    $limit: Int!,
    $offset: Int!,
    $keyword: String,
    $published_at_is_null: Boolean,
    $price_gte: numeric,
    $price_lte: numeric,
  ) {
    search_item_aggregate(
      where: {
        _and: {
          catalog: { id: { _eq: $catalog } },
          price: { _gte: $price_gte, _lte: $price_lte}
        }
      }
      args: { search: $keyword }
    ) {
      aggregate {
        count
      }
    }
    search_item(
      where: {
        _and: {
          catalog: { id: { _eq: $catalog } },
          price: { _gte: $price_gte, _lte: $price_lte}
        }
      }
      args: { search: $keyword }
      limit: $limit
      offset: $offset
    ) {
      id
      sku
      name
      description
      currency
      price
      uom
      manufacturer
      manufacturer_partnumber
      image
      taxonomy_category {
        mdm_code
        mdm_name
      }
    }
  }
`;

// eslint-disable-next-line import/prefer-default-export
export const fetchAllCatalogItemsQuery = gql`
  query SearchCatalogItems
  (
    $catalog: uuid!,
    $limit: Int!,
    $offset: Int!,
    $keyword: String,
    $published_at_is_null: Boolean
  ) {
    search_item_aggregate(
      where: {
        _and: {
          catalog: { id: { _eq: $catalog } }
        }
      }
      args: { search: $keyword }
    ) {
      aggregate {
        count
      }
    }
    search_item(
      where: {
        _and: {
          catalog: { id: { _eq: $catalog } }
        }
      }
      args: { search: $keyword }
      limit: $limit
      offset: $offset
    ) {
      id
      sku
      name
      description
      currency
      price
      uom
      manufacturer
      manufacturer_partnumber
      image
      taxonomy_category {
        mdm_code
        mdm_name
      }
    }
  }
`;

export const MRO_CATALOG_GET_PRODUCT_ITEM = gql`
  query CatalogItemById($productId: uuid!) {
    item_by_pk(id: $productId) {
      id
      sku
      code
      name
      description
      catalog_id
      currency
      price
      uom
      manufacturer
      manufacturer_partnumber
      has_stock
      is_active
      category_id
      taxonomy_category {
        mdm_code
        mdm_name
      }
      noun
      modifier
      item_attribute_values {
        item_id
        attribute_id
        mdm_value
        taxonomy_attribute {
          mdm_code
          mdm_name
          mdm_order
          is_required
        }
      }
      technical_specification
      image
      updated_at
      item_equivalents{
        manufacturer
        part_number
      }
      attached_file
    }

  }
`;

export const MRO_SEARCH_ITEMS_COUNT = gql`
query MRO_SEARCH_ITEMS_COUNT($keywords: String, $category_id: [uuid!] = null, $organization_id: String, $country: String) {
  mdm:cat4mro_search_v1_aggregate(args: {search: $keywords, catalog_type: 2, country: $country}, where: {category: {id: {_in: $category_id}}}) {
    aggregate {
      count
    }
  }
  public_catalog: cat4mro_search_v1_aggregate(args: {search: $keywords, organization_id: $organization_id, catalog_type: 1, country: $country}, where: {category: {id: {_in: $category_id}}}) {
    aggregate {
      count
    }
  }
  cross_reference: cat4mro_search_v1_aggregate(args: {search: $keywords, catalog_type: 3, country: $country}, where: {category: {id: {_in: $category_id}}}) {
    aggregate {
      count
    }
  }
}
`;

// TODO: enviar tipos de catalogos disponibles del usuario
export const MRO_SEARCH_ITEMS = gql`
query MRO_SEARCH_ITEM($limit: Int!, $offset: Int!, $keywords: String, $organization_id: String, $catalog_type: Int, $country: String, $category_id: [uuid!] = null) {
  all: cat4mro_search_v1_aggregate(args: {search: $keywords, organization_id: $organization_id, catalog_type: $catalog_type, country: $country}, where: {category: {id: {_in: $category_id}}}) {
    aggregate {
      count
    }
  }
  data: cat4mro_search_v1(args: {search: $keywords, organization_id: $organization_id, catalog_type: $catalog_type, country: $country}, limit: $limit, offset: $offset, where: {category: {id: {_in: $category_id}}}) {
    id
    code
    name
    description
    manufacturer
    manufacturer_partnumber
    currency
    price
    catalog_id
    category {
      mdm_code
      mdm_name
    }
    catalog {
      id
      name
      type {
        name
      }
      organization {
        id
        name
        tax_id
      }
    }
    item_match
    updated_at
    item_equivalents{
      manufacturer
      part_number
    }
    sku
    centers
    country
    erp_code
    free_search_ranking
    pn_search_ranking
    similarity_ranking
    uom
  }
}
`;

export const MRO_CATALOG_BY_PK = gql`query getCatalogByPk($id: uuid!){
  catalog_by_pk(id: $id) {
    id
    name
    organization {
      id
      name
    }
  }
}`;

export const MRO_SEARCH_INFORMATION_REQUESTS_QUERY = gql`
  query MRO_SEARCH_INFORMATION_REQUESTS(
    $limit: Int!,
    $offset: Int!,
    $order_by: [information_request_order_by!]!,
    $keywords: String
  ) {
    information_request_aggregate(where:
    {
      _or: [
        {number: {_like: $keywords}},
        {name: {_like: $keywords}},
        {search_text: {_like: $keywords}},
        {
          supplier_responses: {
            items: {
              catalog_item: {name: {_like: $keywords}}
            }
          }
        }
      ]
    }){
      __typename
      aggregate {
        count
      }
    }
    information_request(
      limit: $limit,
      offset: $offset,
      order_by: $order_by,
      where: {
        _or: [
          {
            number: { _like: $keywords }
          },
          {
            name: { _like: $keywords }
          },
          {
            search_text: { _like: $keywords }
          },
          {
            supplier_responses: {
              items: {
                catalog_item: {
                  name: {
                    _like: $keywords
                  }
                }
              }
            }
          }
        ]
      }
    ) {
      __typename
      id
      status
      number
      name
      close_date
      created_at
      organization {
        id
        name
      }
      inviteds_count: supplier_responses_aggregate {
        aggregate {
          count
        }
      }
      readeds_count: supplier_responses_aggregate(where: {readed_at: {_is_null: false}}) {
        aggregate {
          count
        }
      }
      answereds_count: supplier_responses_aggregate(where: {_and: [{readed_at: {_is_null: false}}, {answered_at: {_is_null: false}}]}) {
        aggregate {
          count
        }
      }
    }
  }
`;

export const MRO_GET_INFORMATION_REQUEST_QUERY = gql`query MRO_GET_INFORMATION_REQUEST_QUERY($id: uuid!) {
  information_request_by_pk(id: $id) {
    id
    status
    number
    name
    search_text
    requested_quantity
    requested_uom
    expected_delivery_date
    expected_delivery_location
    override_expected_delivery_date
    require_stock_confirmation
    require_delivery_availability
    require_technical_questions
    technical_specification_question
    technical_warranty_question
    technical_usage_question
    technical_manufacture_question
    technical_additional_info_question
    close_date
    message
    attachment
    organization {
      id
      name
    }
    answereds_count: supplier_responses_aggregate(where: {_and: [{readed_at: {_is_null: false}}, {answered_at: {_is_null: false}}]}) {
      aggregate {
        count
      }
    }
    requests:supplier_responses {
      id
      number
      status
      answered_at
      readed_at
      created_at
      observations
      supplier_name
      supplier_tax
      supplier_contact_name
      supplier_contact_email
      supplier_organization {
        id
        name
        tax_id
      }
      items {
        id
        price
        currency
        has_stock
        has_stock_alternative
        stock_quantity
        stock_uom
        stock_observations
        has_delivery_availability
        has_delivery_alternative
        delivery_date
        delivery_observations
        delivery_location
        technical_specification
        technical_warranty
        technical_usage
        technical_manufacture
        technical_additional_info
        score
        average
        created_at
        updated_at
        item_description
        attachment
        catalog_item {
          id
          description
          name
          price
          currency
        }
      }
    },
    responses:supplier_responses(where: {_and: [{readed_at: {_is_null: false}}, {answered_at: {_is_null: false}}]}) {
      id
      number
      answered_at
      readed_at
      created_at
      observations
      supplier_name
      supplier_tax
      supplier_contact_name
      supplier_contact_email
      supplier_organization {
        id
        name
        tax_id
      }
      items {
        id
        price
        currency
        has_stock
        has_stock_alternative
        stock_quantity
        stock_uom
        stock_observations
        has_delivery_availability
        has_delivery_alternative
        delivery_date
        delivery_observations
        delivery_location
        technical_specification
        technical_warranty
        technical_usage
        technical_manufacture
        technical_additional_info
        score
        average
        created_at
        updated_at
        item_description
        attachment
        catalog_item {
          id
          description
          name
          price
          currency
        }
        response {
          observations
        }
      }
    }
  }
}
`;

export const MRO_INSERT_INFORMATION_REQUEST = gql`mutation MRO_INSERT_INFORMATION_REQUEST($data: [information_request_insert_input!]!) {
  insert_information_request(objects: $data) {
    returning {
      id
    }
  }
}`;

export const MRO_GET_COMPARER_RESPONSES = gql`query MRO_GET_COMPARER_RESPONSES (
  $id: uuid
){
  information_response(where: {
      information_request_id: { _eq: $id }
      answered_at: {
        _is_null: false
      },
    }
    order_by: [
      { answered_at: asc }
    ]
  )
  {
    id
    number
    answered_at
    readed_at
    created_at
    supplier_organization {
      id
      name
      tax_id
    }
    items {
      id
      price
      currency
      has_stock
      has_stock_alternative
      stock_quantity
      stock_uom
      stock_observations
      has_delivery_availability
      has_delivery_alternative
      delivery_date
      delivery_observations
      delivery_location
      score
      average
      created_at
      updated_at
      catalog_item {
        id
        description
        name
        price
        currency
      }
    }
  }
}`;

export const MRO_SEARCH_CATALOGS_TYPES = gql`query MRO_SEARCH_CATALOGS_TYPES {
  catalog_type {
    id
    name
    description
    is_public
  }
}
`;

export const MRO_SEARCH_ORGANIZATIONS_COUNTRIES = gql`query MRO_SEARCH_ORGANIZATIONS_COUNTRIES {
  organization(distinct_on: country, where: {country: {_is_null: false}}) {
    code: country
  }
}
`;



// WEBPACK FOOTER //
// ./src/store/graphql/queries/cat4mro.js